module.exports = __webpack_public_path__ + "assets/img/126301.776e1ac3.svg";